import React from 'react'
import styled from 'styled-components'
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded'

const LocationConsentModal = ({ onAllow, onDecline }) => (
  <Backdrop>
    <Panel role='dialog' aria-modal='true' aria-labelledby='loc-consent-title'>
      <Header>
        <IconWrap><LocationOnRoundedIcon style={{ fontSize: 22 }} /></IconWrap>
        <Title id='loc-consent-title'>Share your location with this submission?</Title>
      </Header>

      <Body>
        <P>
          We can record <strong>where this form was submitted</strong> to help verify that
          on-site work was carried out at the building.
        </P>
        <List>
          <li><strong>What's collected:</strong> your device's GPS coordinates (latitude and longitude) at the moment you submit, and their approximate accuracy.</li>
          <li><strong>Why:</strong> to evidence that the submission was made at the building, as part of the audit trail for this task.</li>
          <li><strong>Lawful basis:</strong> your consent. We only collect it if you allow it here.</li>
          <li><strong>It's optional:</strong> declining does not affect your use of the platform or your ability to submit this form.</li>
          <li><strong>Withdraw any time:</strong> change this later under <em>Profile Settings → Location sharing</em>, and your next submissions won't include location.</li>
        </List>
      </Body>

      <Footer>
        <Secondary type='button' onClick={onDecline}>Don't share</Secondary>
        <Primary type='button' onClick={onAllow}>Allow location</Primary>
      </Footer>
    </Panel>
  </Backdrop>
)

export default LocationConsentModal

const Backdrop = styled.div`
  position: fixed; inset: 0;
  background: rgba(12, 19, 43, 0.45);
  z-index: 1400;
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
`

const Panel = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 100%; max-width: 460px;
  box-shadow: 0 20px 48px rgba(0,0,0,0.2);
  overflow: hidden;
  display: flex; flex-direction: column;
`

const Header = styled.div`
  display: flex; align-items: center; gap: 10px;
  padding: 18px 20px 12px;
`

const IconWrap = styled.span`
  display: inline-flex; align-items: center; justify-content: center;
  width: 36px; height: 36px; flex-shrink: 0;
  border-radius: 9px;
  background: ${({ theme }) => `${theme.colors.secondary}1A`};
  color: ${({ theme }) => theme.colors.secondary};
`

const Title = styled.h3`
  margin: 0;
  font-size: 16px; font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
  line-height: 1.3;
`

const Body = styled.div`
  padding: 0 20px 8px;
`

const P = styled.p`
  margin: 0 0 10px;
  font-size: 13px; line-height: 1.5;
  color: ${({ theme }) => theme.colors.grey[700] || '#475569'};
`

const List = styled.ul`
  margin: 0; padding-left: 18px;
  display: flex; flex-direction: column; gap: 7px;
  font-size: 12.5px; line-height: 1.5;
  color: ${({ theme }) => theme.colors.grey[700] || '#475569'};

  strong { color: ${({ theme }) => theme.colors.haiti}; }
`

const Footer = styled.div`
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 20px 18px;
`

const Secondary = styled.button`
  font: inherit;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px; font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
  cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.lighterGrey}; }
`

const Primary = styled.button`
  font: inherit;
  background: ${({ theme }) => theme.colors.secondary};
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px; font-weight: 700;
  color: #fff;
  cursor: pointer;
  &:hover { filter: brightness(1.06); }
`
